// extracted by mini-css-extract-plugin
module.exports = {"canvas_body":"src-modules-project-components-ProjectCanvasPage---canvas_body---oOMjZ","media_library":"src-modules-project-components-ProjectCanvasPage---media_library---2sPUl"};